module.exports = __webpack_public_path__ + "img/buzou4.01595203.png";